// @flow

import CarouselSliderThumbnails from './abstract/CarouselSliderThumbnails';
import { outerWidth } from '../classes/Helpers';

export default class HorizontalCarouselSliderThumbnails extends CarouselSliderThumbnails {
  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement) {
    super.bind(pEl);

    this.calculationProperties = ['left', 'width'];

    const wrapperWidth = this.items.length * (outerWidth(this.items[0]) || 0);
    const wrapperPadding = parseInt(window.getComputedStyle(this.el).paddingRight);
    this.el.style.width = wrapperWidth + wrapperPadding + 'px';
  }
}
